import { render, staticRenderFns } from "./IconEmojiMeh.vue?vue&type=template&id=cd0912c8&"
import script from "./IconEmojiMeh.vue?vue&type=script&lang=js&"
export * from "./IconEmojiMeh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports